<template>
<div class="py-5" ref="cloudChartContainer">
    <highcharts v-if="Object.keys(chartData).length" :options="chartData" ref="cloudChart" />
</div>
</template>
<script>
export default {
    name: "WordCloud",
    props: {
        cloudData: {
            type: Array,
            required: true
        },
        color: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            chartData: {},
        }
    },
    mounted() {
        if(this.cloudData.length) {
            this.plotChart();
        }
        this.resizeObserver = new ResizeObserver(() => {
            this.resizeChart();
        });
        this.resizeObserver.observe(this.$refs.cloudChartContainer);
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },
    watch: {
        cloudData: {
            handler() {
                this.plotChart()
            },
            deep: true
        }
    },
    methods: {
        resizeChart() {
            if (this.$refs.cloudChart.chart) {
                this.$refs.cloudChart.chart.reflow();
            }
        },
        plotChart() {
            let self = this;
            let data = []
            
            this.cloudData.forEach(dataPoint => {
                data.push({
                    name: dataPoint.word,
                    weight: dataPoint.frequency
                })
            })

            this.chartData = {
                chart: {
                    height: 250,
                },
                credits: {
                    enabled: false,
                },
                exporting: {
                    enabled: false
                },
                tooltip: {
                    borderWidth: 0,
                    shadow: {
                        color: "#d6d6d6",
                        opacity: 0.1,
                        width: 10,
                    },
                    borderRadius: 6,
                    backgroundColor: "#ffffff",
                },
                series: [
                    {
                        type: "wordcloud",
                        data: data,
                        name: "Frequency",
                        rotation: {
                            from: 0,
                            to: 0,
                            orientations: 1,
                        },
                        minFontSize: 10,
                        maxFontSize: 20,
                        colors: [self.color],
                        style: { fontWeight: "400" },
                    },
                ],
                title: {
                    text: "",
                },
            };
        }
    }
}
</script>